import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/reviews/appEnv';

export default appStarterFactory(appEnv);
